module.exports = fox._r("images/july4/gift-94.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/july4/gift-94.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/july4/gift-94.png
// module id = 295
// module chunks = 4